/*
NAME: MonitorChartLimits
DESC:Componente resopnsavel por receber um array de um componente pai, fazer o processamento dos 
dados e enviar para o componente filho realizar a montagem do gráico.
props:
- linhas: array de objetos referente aas linhas de um determinado plantio
- item: Array de objeto de um item especifico
- - - - Default
- style: Object, style object to overwrite this component style

NOTES:

*/
import React,{useEffect, useState} from 'react';
import strings from '../../values/strings/strings';
import ChartBarsLimits from '../basic/ChartBarsLimits';

function MonitorChartLimits({linhas, item}) {
    const [chartValues, setChartValues] = useState([]);
    const [limits, setLimits] = useState(null);
    
   useEffect(() => {
      if(linhas && linhas.length > 0){
      let copialinhas = [...linhas]
      let copiaItem = item
      bindData(copialinhas, copiaItem)

      }
   }, [item, linhas])

   const bindData = (arr, obj) => {
      let newChartValues = []

      newChartValues = arr.map((item, i) => {
         return {
            text: item.numero,
            value: item.sementes_metro_total,
         }
      })
      setChartValues(newChartValues)
      
      // Define os limites uma vez, já que são os mesmos para todas as linhas
      if (obj && obj.config_sementesmetro_max !== undefined) {
         setLimits({
            max: obj.config_sementesmetro_max,
            min: obj.config_sementesmetro_min,
            target: obj.config_sementesmetro,
         })
      }
   }

   
    return (
      <ChartBarsLimits 
         title={strings.getString('screen_monitoring_chart_title')} 
         items={chartValues}
         limits={limits}
      />
   );
}

export default MonitorChartLimits;